import { loadAsyncComponent } from 'src/components/AsyncComponent';

export const InviteUsersPopup = loadAsyncComponent(
  () => import(/* webpackChunkName: "InviteUsersPopup" */ './Container'),
  'popup'
);
